import { ALL_OPTION } from "utility/constants";

export const defaultSelectedCongressmen = {
  name: null,
  area: "",
  contact: "63",
  cos: "",
  cosContact: "63",
};

export const allRegion = {
  value: ALL_OPTION,
  label: "All",
};

export const customRegion = {
  value: 0,
  label: "Custom",
};

export const isNotAllOrCustom = (reg) =>
  reg.value !== ALL_OPTION && reg.value !== 0;
